import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const usePortalCleanup = () => {
  const location = useLocation();
  
  useEffect(() => {
    return () => {
      // Clean up any orphaned Radix portals on route change
      const radixPortals = document.querySelectorAll('[data-radix-portal]');
      radixPortals.forEach(portal => {
        try {
          portal.remove();
        } catch (e) {
          console.warn('Portal cleanup failed:', e.message);
        }
      });
    };
  }, [location.pathname]);
};
